import React from 'react';
import { Card as AntdCard } from 'antd';

const Card = ({
  headerTitle = null,
  children,
  className,
  footer,
  bordered = false,
  extra = null,
  bodyStyles,
  headerStyles,
  style,
  ...rest
}) => (
  <AntdCard
    title={headerTitle}
    className={className}
    bordered={bordered}
    extra={extra}
    {...rest}
    style={{ boxShadow: 'none', ...style }}
    styles={{
      header: headerStyles && {
        ...headerStyles,
      },
      body: bodyStyles && {
        ...bodyStyles,
      },
    }}
  >
    {children && children}
    {footer && (
      <div id="card-footer" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        {footer}
      </div>
    )}
  </AntdCard>
);

export default Card;
